/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * building
 */
export interface StructureDamageSeverityHistory { 
    /**
     * primary Key
     */
    id?: number;
    /**
     * ID of the structure
     */
    structureDamageId?: number;
    /**
     * On this date the damage was first noted
     */
    entryDatetime?: string;
    standSicherheit?: number;
    verkehrsSicherheit?: number;
    dauerhaftigkeit?: number;
}

